import React from 'react';
import dayjs from 'dayjs';
import LazyLoad from 'react-lazyload';
import { Button } from '../../components/UI/Elements';

/**
@func util
a custom high-performance filter

@perf
60% faster than the built-in JavaScript filter func

@typedef {(e: *) => boolean} filterFnAny
@param {filterFnAny} fn
@param {*[]} a
@return {*[]}
*/
export const fil = (fn, a) => {
  const f = []; // final
  for (let i = 0; i < a.length; i++) {
    if (fn(a[i])) {
      f.push(a[i]);
    }
  }
  return f;
};

export const getDeepObjectValue = (
  deepObject: any,
  pathsArray: string[]
): any => {
  const result = pathsArray.reduce(
    (obj, key): any => (obj && obj[key] !== 'undefined' ? obj[key] : undefined),
    deepObject
  );
  return result;
};

export const returnCurrentZone = (zones) =>
  zones.find((val) => val.value === process.env.GATSBY_ZONE);

export const returnLocale = (url) => {
  if (url.match(/(?:fr-)/)) {
    return 'fr';
  }
  if (url.match(/(?:en-)/)) {
    return 'en';
  }
  if (url.match(/(?:pt-)/)) {
    return 'pt-PT';
  }
  if (url.match(/(?:it-)/)) {
    return 'it';
  }
  if (url.match(/(?:es-)/)) {
    return 'es';
  }
  if (url.match(/(?:nl-)/)) {
    return 'nl';
  }
  if (url.match(/(?:de-)/)) {
    return 'de';
  }
  return 'en';
};

export const returnLocalisedPath = (locale, path) => `/${locale}/${path || ''}`;

export const returnCurrencyCharFromCode = (code) => {
  switch (code) {
    case 'EUR':
      return '€';
      break;
    case 'USD':
      return '$';
      break;
    case 'CAD':
      return '$';
      break;
    case 'GBP':
      return '£';
      break;
    default:
      return '';
  }
};

export const returnFormatedDate = (date) => {
  if (process.env.GATSBY_ZONE === 'us') {
    return dayjs(date).format('MM/DD/YYYY');
  } else if (process.env.GATSBY_ZONE === 'ca') {
    return dayjs(date).format('YYYY/MM/DD');
  } else {
    return dayjs(date).format('DD/MM/YYYY');
  }
};

export const returnDecodedProductId = (productId) => {
  if (typeof window !== 'undefined' && productId) {
    try {
      const urlArr = window.atob(productId).split('/');
      const id = urlArr[urlArr.length - 1];
      return parseInt(id);
    } catch (error) {
      return '';
    }
  }
  return '';
};

export const capitlizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const returnKlavyoLang = (locale) => {
  if (locale.includes('en')) {
    return locale.split('-')[1];
  }
  return locale.split('-')[0];
};

export const openInNewTab = (url) => {
  if (typeof window !== 'undefined') {
    const win = window.open(url, '_blank');
    win.focus();
  }
};

export const returnLocalisedNodes = (nodes, locale) =>
  fil(
    (node) =>
      node.node_locale.toLowerCase() === locale ||
      (node.node_locale === 'en' &&
        (locale.includes('en-eu') || locale.includes('en-gb'))),
    nodes
  );

export const returnNodeFromId = (nodes, locale) =>
  fil(
    (node) =>
      node.node_locale.toLowerCase() === locale ||
      (node.node_locale === 'en' &&
        (locale.includes('en-eu') || locale.includes('en-gb'))),
    nodes
  );

export const formatContentfulComponentProps: any = (props, toLog) => {
  const ComponentsProps = {};
  if (toLog) console.log(props, props.items);
  if (props && props.items) {
    props.items.forEach((item) => (ComponentsProps[item.key] = item));
  }
  return ComponentsProps;
};

export const returnShopifyVariant = (shopifyProduct, variant) =>
  shopifyProduct &&
  shopifyProduct.variants?.filter((v) => {
    if (!variant) {
      return;
    }

    // product with color & diopter variant
    if (variant.color && variant.diopter) {
      return (
        v.selectedOptions?.color?.toLowerCase() ===
          variant.color.shopifyKey?.toLowerCase() &&
        v.selectedOptions.diopter === variant.diopter
      );
    }

    // product with color & size variant
    if (variant.color && variant.size) {
      return (
        v.selectedOptions?.color?.toLowerCase() ===
          variant.color.shopifyKey?.toLowerCase() &&
        v.title.slice(-1).toLowerCase() === variant.size.value.toLowerCase()
      );
    }

    // product with color variant
    if (variant.color) {
      return (
        v.selectedOptions?.color?.toLowerCase() ===
        variant.color.shopifyKey?.toLowerCase()
      );
    }

    // product with price variant
    if (variant.denominations) {
      return v.sku?.toLowerCase() === variant.denominations.toLowerCase();
    }

    // product without variant
    if (shopifyProduct.variants.length === 1) {
      return v;
    }
  });

export const returnErrMessage = (err) => {
  if (err && err.response && err.response.statusText) {
    return `${err.response.status} ${err.response.statusText}`;
  }
};

export const returnAPISlug = (slug) =>
  `https://nooz-optics-${process.env.GATSBY_ZONE}.netlify.app/.netlify/functions/${slug}`;
// if (process.env.NODE_ENV === "development") {
//   return `/.netlify/functions/${slug}`;
// }

export const updateUrlParams = (key, value) => {
  // handle url param update
  if (typeof history !== 'undefined') {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    history.replaceState({}, '', url.href);
  }
};

export const handleReturnWithLazy = (el, isLazy) => {
  if (isLazy) {
    return (
      <LazyLoad
        style={{ display: 'inline' }}
        height='200vh'
        offsetTop={200}>
        {el}
      </LazyLoad>
    );
  }
  return el;
};

export const getRandomString = (length) => {
  const randomChars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length)
    );
  }
  return result;
};

export const subHeaderScrollTrigger = 400;

export const tabsButtonLeft = {
  icon: {
    iconKey: 'HiOutlineChevronLeft',
    size: 'sm',
    color: { classname: 'gray-700' },
  },
  type: 'circular',
  color: { classname: 'primary' },
};

export const tabButtonRight = {
  icon: {
    iconKey: 'HiOutlineChevronRight',
    size: 'sm',
    color: { classname: 'gray-700' },
  },
  type: 'circular',
  color: { classname: 'primary' },
};
